export default __webpack_public_path__ + "static/media/excel.e8e7d1c2.svg";